/** A delivered result for analytics, excluding stopped and failed replies. */
export function hasSuccessfulAssistantResult(message) {
  if (message?.role?.toLowerCase?.() !== 'assistant') return false;
  if (message.isError || message.hasError || message.error
    || message.flags?.hasError || message.flags?.isUserCancelled
    || ['error', 'aborted', 'cancelled', 'canceled', 'interrupted'].includes(message.stopReason)) return false;

  const text = typeof message.content === 'string' ? message.content
    : Array.isArray(message.content) ? message.content
      .filter(part => part?.type === 'text' && typeof part.text === 'string')
      .map(part => part.text).join('\n') : '';
  return !!(text.trim()
    || (Array.isArray(message.files) && message.files.some(Boolean))
    || (Array.isArray(message.images) && message.images.some(Boolean)));
}
